import React from 'react'
import logo from '../../assets/Bench_logo.png'

const Logo = ({ sizeClass = 'w-10 h-10', alt = 'AJA Bench' }) => {
  return (
    <div className={`${sizeClass} rounded-xl flex items-center justify-center overflow-hidden`}>
      <img src={logo} alt={alt} className="w-full h-full object-contain" />
    </div>
  )
}

export default Logo
